import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import LockIcon from '@mui/icons-material/Lock';

const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    borderRadius: '16px',
    padding: '24px',
    maxWidth: '500px',
  }
}));

const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '24px',
}));

const LockIconStyled = styled(LockIcon)(({ theme }) => ({
  fontSize: '64px',
  color: '#0B91D6',
}));

const Title = styled(DialogTitle)(({ theme }) => ({
  textAlign: 'center',
  fontSize: '24px',
  fontWeight: 700,
  color: '#121927',
  padding: '0 0 16px 0',
}));

const Content = styled(DialogContent)(({ theme }) => ({
  textAlign: 'center',
  padding: '0 0 24px 0',
}));

const Description = styled(Typography)(({ theme }) => ({
  fontSize: '16px',
  color: '#6B7280',
  marginBottom: '16px',
}));

const FeatureList = styled(Box)(({ theme }) => ({
  textAlign: 'left',
  margin: '24px 0',
  padding: '16px',
  backgroundColor: '#F9FAFB',
  borderRadius: '8px',
}));

const FeatureItem = styled(Typography)(({ theme }) => ({
  fontSize: '14px',
  color: '#374151',
  marginBottom: '8px',
  '&:before': {
    content: '"✓"',
    color: '#0B91D6',
    fontWeight: 700,
    marginRight: '8px',
  }
}));

const Actions = styled(DialogActions)(({ theme }) => ({
  justifyContent: 'center',
  gap: '12px',
  padding: '0',
}));

const UpgradeButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#0B91D6',
  color: '#ffffff',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  padding: '12px 32px',
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: '#0277BD'
  }
}));

const CancelButton = styled(Button)(({ theme }) => ({
  color: '#6B7280',
  fontFamily: 'Inter, sans-serif',
  fontSize: '16px',
  fontWeight: 600,
  textTransform: 'none',
  padding: '12px 32px',
  borderRadius: '8px',
  '&:hover': {
    backgroundColor: '#F3F4F6'
  }
}));

const UpgradeToProModal = ({ open, onClose, featureName }) => {
  const handleUpgrade = () => {
    window.location.href = '/pricing';
  };

  // Safety check: Don't render modal if it shouldn't be shown
  // This prevents flash of modal during permission loading
  if (!open) {
    return null;
  }

  return (
    <StyledDialog open={open} onClose={onClose}>
      <IconContainer>
        <LockIconStyled />
      </IconContainer>
      <Title>Upgrade to Pro to Access All Features</Title>
      <Content>
        <Description>
          {featureName ? `"${featureName}" is a premium feature.` : 'This is a premium feature.'}
        </Description>
        <Description>
          Only "View Profile" is available for free. Upgrade to Pro to unlock all premium features and take your business to the next level!
        </Description>
        <FeatureList>
          <FeatureItem>Access to Performance Dashboard</FeatureItem>
          <FeatureItem>Reputation Management Tools</FeatureItem>
          <FeatureItem>Task Management System</FeatureItem>
          <FeatureItem>Free Website Builder</FeatureItem>
          <FeatureItem>EDM Templates</FeatureItem>
          <FeatureItem>Priority Support</FeatureItem>
        </FeatureList>
      </Content>
      <Actions>
        <CancelButton onClick={onClose}>
          Maybe Later
        </CancelButton>
        <UpgradeButton onClick={handleUpgrade}>
          Upgrade to Pro
        </UpgradeButton>
      </Actions>
    </StyledDialog>
  );
};

export default UpgradeToProModal;
